import { trackSubscriptionPaywallClicked, trackSubscriptionPaywallShown } from "app/utils/mixpanel_tracking"
import { nextCreditsTier, tierDisplayName } from "shared/utils/tiers"

export type CreditsUpgradeTracking = Omit<Parameters<typeof trackSubscriptionPaywallClicked>[0], "targetTier">

// The target is the plan one step up, the same plan the upgrade modal offers.
const withTargetTier = (tracking: CreditsUpgradeTracking, tier: string) => {
  const targetTier = nextCreditsTier(tier)

  return { ...tracking, targetTier: targetTier ? tierDisplayName(targetTier) : undefined }
}

export const trackCreditsUpgradeClick = (tracking: CreditsUpgradeTracking, tier: string) =>
  trackSubscriptionPaywallClicked(withTargetTier(tracking, tier))

export const trackCreditsUpgradeShown = (tracking: CreditsUpgradeTracking, tier: string) =>
  trackSubscriptionPaywallShown(withTargetTier(tracking, tier))
